import * as actionTypes from "../../actionLabels/index";

const initialState = {
  getUserWiseBankDetails: [],
  error: null,
};

const bankUpdateDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_WISE_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        getUserWiseBankDetails: action.payload,
        error: null,
      };

    case actionTypes.GET_USER_WISE_BANK_DETAILS_FAIL:
      return {
        ...state,
        getUserWiseBankDetails: [],
        error: action.payload,
      };

    default: {
      return { ...state };
    }
  }
};
export default bankUpdateDetailsReducer;
